<template>
  <div class="logo">
    <RouterLink :to="{ name: 'home' }" aria-label="Vallarx home" class="logo-link">
      <svg width="30" height="30" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
        <!-- Crenellated wall tapering to a "V" point: vallum + arx -->
        <path class="mark-wall" d="M3 5H10V10H14V5H22V10H26V5H33V19L18 33L3 19Z" />
        <path class="mark-valley" d="M11 14L18 21L25 14V19.5L18 26.5L11 19.5Z" />
      </svg>
      <span class="logo-text">Vallarx</span>
    </RouterLink>
  </div>
</template>
<script setup lang="ts">
import { RouterLink } from 'vue-router';
</script>
<style scoped lang="scss">
.logo-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.mark-wall {
  fill: rgb(var(--v-theme-primary));
}
.mark-valley {
  fill: rgb(var(--v-theme-primary-darken-1));
}
.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  line-height: 1;
  color: rgb(var(--v-theme-on-surface));
}
</style>
